// MARK: Style
import "./style.scss";

// MARK: React
import * as React from "react";

// MARK: Mobx
import { observer, inject } from "mobx-react";

// MARK: Components
import Dialog from "../Dialog";
import Button from "../Button";
import CircularProgress from "../CircularProgress";
import RatedText from "../RatedText";
import CloseFloatingBtn from "../CloseFloatingBtn";

// MARK: Stores
import SurveyStore from "../../stores/SurveyStore";

// MARK: Resources
import strings from "../../resources/strings";

interface IProps {
	surveyStore: SurveyStore;
}

@inject("surveyStore")
@observer
export default class SurveyAnswerDialog extends React.Component<IProps> {
	public render() {
		const { surveyStore } = this.props;
		const { selectedSurvey } = surveyStore;
		return (
			<Dialog
				open={surveyStore.surveyAnswerOpen}
				style={{ margin: "10px" }}
			>
				{
					surveyStore.answerLoading ?
						<CircularProgress /> :
						selectedSurvey && (
							<div className="answerDialog">
								<div className="infoRow">
									<p className="infoRowTitle">{strings.surveys.answer.name}</p>
									<p>{selectedSurvey.name}</p>
								</div>
								<div className="infoRow">
									<p className="infoRowTitle">{strings.surveys.answer.email}</p>
									<p>{selectedSurvey.email}</p>
								</div>
								<div className="infoRow">
									<p className="infoRowTitle">{strings.surveys.answer.phone}</p>
									<p>{selectedSurvey.phone}</p>
								</div>
								<div className="infoRow averageRateRow">
									<RatedText
										text={strings.surveys.answer.nps.title}
										grade={selectedSurvey.nps}
										textSize={20}
									/>
									<p className="categoryDescripition">{strings.surveys.answer.nps.description}</p>
								</div>
								{selectedSurvey.metaData.map((metaData) => (
									<div className="infoRow" key={metaData.tag}>
										<p className="infoRowTitle">{metaData.tag}</p>
										<p>{metaData.value}</p>
									</div>
								))}
								{selectedSurvey.answerSections.map((answerSection) => (
									<>
										<p className="categoryDescripition">{answerSection.title}</p>
										{answerSection.answers.map((answer, index) => (
											<>
												<RatedText
													key={`${answer.question.id}-${index}`}
													text={answer.question.title}
													grade={answer.rate}
												/>
												{answer.comment !== "" && (
													<div className="commentCard" key={answer.comment + index + answer.question.id} >
														<p>"{answer.comment}"</p>
													</div>
												)}
											</>
										))}
									</>
								))}
								<div className="commentRow">
									<p className="commentRowTitle">{strings.surveys.answer.comment}</p>
									<p>{selectedSurvey.comment}</p>
								</div>
							</div>
						)
				}
				<Button
					onClick={surveyStore.closeSurveyAnswerDialog}
					style={{ backgroundColor: "#0081B0", margin: "0 auto", color: "white" }}
				>
					{strings.surveys.answer.buttons.back}
				</Button>
				<CloseFloatingBtn
					close={surveyStore.closeSurveyAnswerDialog}
				/>
			</Dialog>
		);
	}
}
